import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const ComputerGlyph = /*#__PURE__*/createElement("g", {
  id: "computer"
}, /*#__PURE__*/createElement("path", {
  d: "M62.81 23.03V52.6H21.53V23.03h41.28m.44-3H21.1c-1.42 0-2.56 1.15-2.56 2.56v33h47.28v-33a2.58 2.58 0 00-2.57-2.56zM49.32 58.99v.69c0 .21-.17.38-.38.38H35.06a.38.38 0 01-.38-.38v-.69H14.36v1.98c0 1.66 1.34 3 3 3h49.28c1.66 0 3-1.34 3-3v-1.98H49.32z"
}));
const Computer = createSvg({
  name: 'computer',
  path: ComputerGlyph
});

export default Computer;
export { ComputerGlyph };
